<template>
  <div>
    <LayoutContent>
      <SectionTitle :label="$t('label.returnRefund')" />
      <v-container class="rounded-lg my-8 pa-5 elevation-3">
        <div class="px-5 text-center">
          <div class="ma-auto my-8" style="width: 30%">
            <p class="font-weight-bold primary--text text--darken-1 text-center text-h5 mb-5">{{ $t('message.letUsUnderstandMoreOfTheSituation') }}</p>
            <v-radio-group v-model="form.reason" column class="ma-auto" :rules="$rules.requiredRules">
              <v-radio :label="$t('label.defectedProduct')" :value="ReturnRefund.DEFECTED_PRODUCT"></v-radio>
              <v-radio :label="$t('label.incorrectProduct')" :value="ReturnRefund.INCORRECT_PRODUCT"></v-radio>
            </v-radio-group>
          </div>
          <v-textarea v-model="form.comment" :placeholder="$t('placeholder.typeHere')" :rules="$rules.requiredRules" counter="250"></v-textarea>
          <div class="d-flex flex-row my-4">
            <div class="mx-auto">
              <label for="upload-file" v-show="files.files.length < 4">
                <div class="d-flex flex-column upload-photo-border rounded px-8 py-3">
                  <UploadPhoto class="align-self-center" />
                  <input type="file" id="upload-file" hidden @input="selectFile" />
                  <span class="primary--text text--darken-1">{{ $t('label.uploadPhoto') }}</span>
                </div>
              </label>
            </div>
          </div>
          <div class="d-flex flex-row my-4">
            <div v-for="(image, index) in imgSrc" :key="index" class="position-relative">
              <img class="rounded-1r ma-3" width="150" height="150" :src="image" />
              <v-icon class="close-circle white d-flex primary--text text--darken-1 rounded-circle x-large" @click="removeImage(index)">mdi-close</v-icon>
            </div>
            <div v-show="files.files.length" class="ml-8 align-self-center primary--text text--darken-1">{{ files.files.length }} of 4</div>
          </div>
          <app-button invert gradient :label="$t('button.next')" @click="submitReason" width="12rem" class="mt-auto" />
        </div>
      </v-container>
    </LayoutContent>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'

import SectionTitle from '@/components/SectionTitle.vue'
import LayoutContent from '../layouts/LayoutContent.vue'
import UploadPhoto from '@/assets/icons/upload-photo.svg'
import { ReturnRefund } from '@/constants/enums'

import { COMMON } from '@/api'
import { localeHelper } from '@/utils'

export default {
  name: 'Refund',
  components: { LayoutContent, SectionTitle, UploadPhoto },
  data: () => ({
    imgSrc: [],
    files: new DataTransfer(),
    form: {
      reason: '',
      comment: ''
    },
    ReturnRefund
  }),
  computed: {
    formIsValid() {
      if (this.form.reason.length !== 0 && this.form.comment.length > 0 && this.imgSrc.length > 0) return true
      else return false
    }
  },
  mounted() {
    console.log('HSH', this.$route.hash && this.$route.hash.replace('#', ''))
  },
  methods: {
    ...mapMutations('order', ['storeRefundForm']),
    selectFile(event) {
      if (this.files.files.length < 4) {
        let file = new File(event.target.files, event.target.files[0].name)
        this.files.items.add(file)
        this.imgSrc.push(URL.createObjectURL(file))
      }
    },
    removeImage(index) {
      this.imgSrc.splice(index, 1)
      this.files.items.remove(index)
    },
    async submitReason() {
      if (this.formIsValid) {
        let uploadRes
        if (this.files.files.length > 0) {
          let formData = new FormData()
          for (const file of this.files.files) {
            formData.append('media[]', file)
          }
          const uploadMediaData = {
            name: 'refund',
            formData
          }
          uploadRes = await COMMON.uploadMedia(uploadMediaData)
        }

        let url = []
        if (uploadRes && uploadRes.status == 'Success') {
          url = uploadRes.url
        }

        let body = {
          order_id: this.$route.params.order_id,
          product_id: this.$route.params.product_id,
          reason: this.form.reason,
          comment: this.form.comment
        }

        if (this.$route.hash) Object.assign(body, { product_volume_variation_id: this.$route.hash.replace('#', '') })

        if (url.length > 0) {
          body = {
            ...body,
            ...{
              medias: {
                medias: url
              }
            }
          }
        }

        this.storeRefundForm(body)
        this.$router.push({ name: this.$constants.ROUTE_NAME.ORDER_RETURN_PICKUP })
      } else this.$toast.error(localeHelper.getMessage('error.pleaseFillInAllFields'))
    }
  }
}
</script>

<style lang="scss" scoped>
.upload-photo-border {
  border: 1px solid var(--v-primary-darken1);
}
</style>
